export const PepperList = {
floders:[
    {
        title: "十天眾素材",
        list: [
        { value: "#Port_Breeze_Archipelago", imagepath: "https://i.imgur.com/Npc9x6F.jpg" },
        { value: "#Port_Breeze_Archipelago", imagepath: "https://i.imgur.com/bk0JAtp.jpg" },
        { value: "#Valtz_Duchy", imagepath: "https://i.imgur.com/aQ7dYqJ.jpg" },
        { value: "#Auguste_Isles", imagepath: "https://i.imgur.com/Ybvmxki.jpg" },
        { value: "#Lumacie_Archipelago", imagepath: "https://i.imgur.com/0G7rObi.jpg" },
        { value: "#Lumacie_Archipelago", imagepath: "https://i.imgur.com/AHVRH2n.jpg" },
        { value: "#Albion_Citadel", imagepath: "https://i.imgur.com/bcGRE3G.jpg" },
        { value: "#Albion_Citadel", imagepath: "https://i.imgur.com/apfAnSk.jpg" },
        { value: "#Mist_Shrouded_Isle", imagepath: "https://i.imgur.com/UHIMORq.jpg" },
        { value: "#Mist_Shrouded_Isle", imagepath: "https://i.imgur.com/Vj1ravj.jpg" },
        { value: "#Amalthea_Island", imagepath: "https://i.imgur.com/xUusYa3.jpg" },
        { value: "#Amalthea_Island", imagepath: "https://i.imgur.com/8KmKK12.jpg" },
        { value: "#Former_Capital_Mephorash", imagepath: "https://i.imgur.com/J6DTs1l.jpg" }
        ]
    },
    {
        title: "轉世召喚 / 十賢者素材",
        list: [
        { value: "#Kluger_Island", imagepath: "https://i.imgur.com/lIlKpYH.jpg" },
        { value: "#Kluger_Island", imagepath: "https://i.imgur.com/2jUsUOV.jpg" },
        { value: "#Bestia_Island", imagepath: "https://i.imgur.com/BJAWHzj.jpg" },
        { value: "#Bestia_Island", imagepath: "https://i.imgur.com/pRe0SPV.jpg" },
        { value: "#Bestia_Island", imagepath: "https://i.imgur.com/ifwO16V.jpg" },
        { value: "#Reiche_Island", imagepath: "https://i.imgur.com/eqsMklZ.jpg" },
        { value: "#Reiche_Island", imagepath: "https://i.imgur.com/1DeRbcq.jpg" },
        { value: "#Reiche_Island", imagepath: "https://i.imgur.com/dBX87yu.jpg" },
        { value: "#Starke_Island", imagepath: "https://i.imgur.com/pTDhVIp.jpg" },
        { value: "#Starke_Island", imagepath: "https://i.imgur.com/J5ntup4.jpg" }
        ]
    },
    {
        title: "方陣",
        list: [
        { value: "#Zinkenstill", imagepath: "https://i.imgur.com/vQiilub.png" },
        { value: "#Zinkenstill", imagepath: "https://i.imgur.com/02JyU0g.png" },
        { value: "#Zinkenstill", imagepath: "https://i.imgur.com/Xn1Iuar.png" },
        { value: "#Zinkenstill", imagepath: "https://i.imgur.com/Ag5pB0U.png" },
        { value: "#Zinkenstill", imagepath: "https://i.imgur.com/D5giB4s.png" },
        { value: "#Zinkenstill", imagepath: "https://i.imgur.com/whFxCQm.png" }
        ]
    },
    {
        title: "方陣HL",
        list: [
        { value: "#Port_Breeze_Archipelago", imagepath: "https://i.imgur.com/88qaMTE.png" },
        { value: "#Valtz_Duchy", imagepath: "https://i.imgur.com/oY0dHvD.png" },
        { value: "#Auguste_Isles", imagepath: "https://i.imgur.com/sJ5ts8x.png" },
        { value: "#Lumacie_Archipelago", imagepath: "https://i.imgur.com/7XAhjZf.png" },
        { value: "#Albion_Citadel", imagepath: "https://i.imgur.com/gJlZSRQ.png" },
        { value: "#Mist_Shrouded_Isle", imagepath: "https://i.imgur.com/qY8qpYN.png" }
        ]
    },
    {
        title: "マグナ II / Omega II / 120",
        list: [
        { value: "#Kluger_Island", imagepath: "https://i.imgur.com/CZzvHoZ.png" },
        { value: "#Kluger_Island", imagepath: "https://i.imgur.com/MTp0nqV.png" },
        { value: "#Kluger_Island", imagepath: "https://i.imgur.com/oJHykbv.png" },
        { value: "#Kluger_Island", imagepath: "https://i.imgur.com/nFGFG52.png" },
        { value: "#Kluger_Island", imagepath: "https://i.imgur.com/1iJmZZf.png" },
        { value: "#Kluger_Island", imagepath: "https://i.imgur.com/LZkC0cO.png" }
        ]
    },
    {
        title: "旧召喚マルチ / 召喚石 I (古方陣) + HL",
        list: [
        { value: "#Port_Breeze_Archipelago", imagepath: "https://i.imgur.com/8t5g7NP.png" },
        { value: "#Valtz_Duchy", imagepath: "https://i.imgur.com/RF8ugb4.png" },
        { value: "#Auguste_Isles", imagepath: "https://i.imgur.com/sHc9raM.png" },
        { value: "#Lumacie_Archipelago", imagepath: "https://i.imgur.com/4kI25kT.png" },
        { value: "#Albion_Citadel", imagepath: "https://i.imgur.com/bk3tsbG.png" },
        { value: "#Mist_Shrouded_Isle", imagepath: "https://i.imgur.com/bVA9h2k.png" }
        ]
    },
    {
        title: "召喚マルチHL / Tier 2 Summon Raids / 召喚石 II",
        list: [
        { value: "#Golonzo_Island", imagepath: "https://i.imgur.com/mx2SiJo.png" },
        { value: "#Amalthea_Island", imagepath: "https://i.imgur.com/X9ZWHWv.png" },
        { value: "#Auguste_Isles", imagepath: "https://i.imgur.com/6mnoVdV.png" },
        { value: "#Former_Capital_Mephorash", imagepath: "https://i.imgur.com/rcdoNvp.png" },
        { value: "#Albion_Citadel", imagepath: "https://i.imgur.com/9qx0BLp.png" },
        { value: "#Mist_Shrouded_Isle", imagepath: "https://i.imgur.com/Ch5JEoZ.png" }
        ]
    },
    {
        title: "天司",
        list: [
        { value: "#Dydroit_Belt", imagepath: "https://i.imgur.com/jZCArAO.png" },
        { value: "#Merkmal_Island", imagepath: "https://i.imgur.com/2Qw6iUm.png" },
        { value: "#Silverwind_Stretch_North_Vast", imagepath: "https://i.imgur.com/KMQ65Ea.png" },
        { value: "#Groz_Island", imagepath: "https://i.imgur.com/8UiC0vR.png" },
        { value: "#Bestia_Island", imagepath: "https://i.imgur.com/Ixwam46.png" }
        ]
    },
    {
        title: "巴哈 (+HL) / 佐伊 / 四象 (+HL) / 路西法（+HARD）",
        list: [
        { value: "#Zinkenstill", imagepath: "https://i.imgur.com/PW10WcJ.png" },
        { value: "#Zinkenstill", imagepath: "https://i.imgur.com/UknFJs9.png" },
        { value: "#Bestia_Island", imagepath: "https://i.imgur.com/ZEsIglU.png" },
        { value: "#Dydroit_Belt", imagepath: "https://i.imgur.com/Tuzad0m.png" },
        { value: "#The_Edgelands", imagepath: "https://i.imgur.com/hGSxRRV.png"},
        ]
    },
    {
        title: "高寶",
        list: [
        { value: "#Golonzo_Island", imagepath: "https://i.imgur.com/y8IWeG8.png" },
        { value: "#Amalthea_Island", imagepath: "https://i.imgur.com/hpYDeLA.png" },
        { value: "#Dydroit_Belt", imagepath: "https://i.imgur.com/udrhkn5.png" },
        { value: "#Former_Capital_Mephorash", imagepath: "https://i.imgur.com/dx9KFCY.png" },
        { value: "#Golonzo_Island", imagepath: "https://i.imgur.com/T8NRvxX.png" },
        { value: "#Mist_Shrouded_Isle", imagepath: "https://i.imgur.com/UeaYn49.png" }
        ]
    },
    {
        title: "虛空 / 羅賽塔",
        list: [
        { value: "#Dydroit_Belt", imagepath: "https://i.imgur.com/pwCY21U.png" },
        { value: "#Agastia", imagepath: "https://i.imgur.com/QdcYVo6.png" },
        { value: "#Lumacie_Archipelago", imagepath: "https://i.imgur.com/BnKJrUk.png" },
        ]
    },
    {
        title: "EX 職業",
        list: [
        { value: "#Zinkenstill", imagepath: "https://i.imgur.com/e4ikiZG.png" },
        { value: "#Auguste_Isles", imagepath: "https://i.imgur.com/zx2zANn.png" },
        { value: "#Golonzo_Island", imagepath: "https://i.imgur.com/2mu0BYv.png" },
        { value: "#Golonzo_Island", imagepath: "https://i.imgur.com/161MuiQ.png" },
        { value: "#Port_Breeze_Archipelago", imagepath: "https://i.imgur.com/DRmkqGi.png" },
        { value: "#Port_Breeze_Archipelago", imagepath: "https://i.imgur.com/6btdF0p.png" },
        { value: "#Amalthea_Island", imagepath: "https://i.imgur.com/VLOsBzN.png" },
        { value: "#Amalthea_Island", imagepath: "https://i.imgur.com/ERav4n2.png" },
        { value: "#Lumacie_Archipelago", imagepath: "https://i.imgur.com/KntTyig.png" },
        { value: "#Former_Capital_Mephorash", imagepath: "https://i.imgur.com/jLosnBo.png" }
        ]
    },
    {
        title: "特殊 / 其他",
        list: [
        { value: "#Amalthea_Island", imagepath: "https://i.imgur.com/BTJj4V0.jpg" },
        { value: "#Golonzo_Island", imagepath: "https://i.imgur.com/6OjbweA.jpg" },
        { value: "#Golonzo_Island", imagepath: "https://i.imgur.com/bBGqRNq.png" },
        { value: "#Amalthea_Island", imagepath: "https://i.imgur.com/dinC8rY.png" }
       ]
    }
]
}

export const MissionList = [
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "第64章 逡巡の夜"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "第48章 小さな覚悟"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "第47章 封印の森"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "姿を消した村人"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "失せ物の中に"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "近所のばあちゃん"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "虫取り名人"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "店主とドラ息子"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "森のかくれんぼ"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "第46章 エルステ帝国皇帝"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "第45章 小さな竜と少女"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "はじまりの場所"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "因縁の相手"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "ティアマト・マグナ討伐戦"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "コロッサス・マグナ討伐戦"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "リヴァイアサン・マグナ討伐戦"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "ユグドラシル・マグナ討伐戦"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "シュヴァリエ・マグナ討伐戦"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "セレスト・マグナ討伐戦"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "星の瞬き"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "星の囁き"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "受け継がれる意思"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "邂逅、黒銀の翼"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "降臨、調停の翼"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "邂逅、黒銀の翼ＨＬ"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "第115章 神聖エルステ帝国"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "第1章 風の出会い"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "家出したみぃちゃん"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "崩落した橋"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "散らばった積荷"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "シェロとルリアのよろず屋"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "他人を救う覚悟"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "第116章 もうひとりのオーキス"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "第2章 操舵士の決意"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "グリフォン討伐戦"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "お人形と女の子"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "リンゴの恨み"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "そこをどけ！ 百人将ダリル"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "絶望しか見えない音楽会"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "第118章 憧憬からの問い"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "第4章 決戦、嵐の守護神"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "ティアマト討伐戦"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "ナタク討伐戦"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "ティアマト・マグナＨＬ"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "ナタクＨＬ"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "ヒヨッコ騎空団"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "行方不明の子供"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "風に揺れるルリアは大丈夫"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "第117章 新たな脅威"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "第3章 帝国の真意"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "悪徳ブローカー"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "3つの依頼"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "商人の才覚"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "男前限定、ラカムゥゥゥゥ"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "グラサイ戦隊 キクウジャー"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "崩壊、危機、乗り越えて"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "第5章 燈の島"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "旅の商人からの依頼"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "盗賊と魔物"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "取り残された職人"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "大酒飲みの恒例行事"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "マチョハン堕つ"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "第122章　真贋の答え"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "第6章 想いは陽炎の如く"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "ザリチュナルフレイム討伐戦"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "砂漠の狩猟大会"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "ビィのプライド"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "小さな依頼主"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "幸運の手芸品を求めて"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "第7章 地の底に眠るは…"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "依頼主の勘違い"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "鉱山跡で宝探し"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "工場長と放蕩息子"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "ドラフの胸には夢いっぱい"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "あの頃の私よりも"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "第8章 鉄の巨人"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "コロッサス討伐戦"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "フラム＝グラス討伐戦"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "コロッサス・マグナＨＬ"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "フラム＝グラスＨＬ"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "幻の生命体"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "大公府からの依頼"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "特務官からの依頼"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "あらぶる庶民派お姫様"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "ライバル出現！ お父さん達"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "第12章 大瀑布の決戦"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "リヴァイアサン討伐戦"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "マキュラ・マリウス討伐戦"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "グラニ討伐戦"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "リヴァイアサン・マグナＨＬ"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "マキュラ・マリウスＨＬ"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "伝説のお宝探し"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "ビィの修行"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "メランコリックルリア"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "あわてんぼうの殺人事件"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "第10章 征野の邂逅"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "おいしい珊瑚"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "密漁者は誰だ"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "珊瑚調査隊"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "５万匹のワタリガニ"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "小生意気な珍味ソミニカ"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "第9章 雲上の水平線"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "インペリアルガード討伐戦"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "祭と喧嘩は海の華"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "リンゴのお菓子"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "水辺の魔物"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "アウギュステ銘菓"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "漁業の危機"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "揉みたい！ふんどし祭り"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "第11章 復讐の戦騎"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "とある奇病の特効薬"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "シェロの警護"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "幽霊の正体見たり……"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "ぱっつん限定枕投げ"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第40章 謀略の果て"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "涙を流したスーテラ姉様"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第52章 悪意の終結"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第39章 黒き真意"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第13章 太古の森"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "美味しい匂い"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "ルーマシーの果物"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "人助けに注意"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "剣吞なお香"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "世界一カワイイ勉強会"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第51章 もう一つの旅"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第38章 悪意の謀略"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "であえであえ、ゴザエモン！"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第14章 薔薇散る剣閃"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "エンシェントドラゴン討伐戦"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "よろず屋の危機"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "怪しい届け物"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "危険なキノコ狩り"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第53章 再起への標"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第50章 再会と試練"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第37章 森に眠る歴史"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第15章 忘却の遺跡"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "ローズクイーン討伐戦ＨＬ"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "桃色キノコ"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "ごちそうを獲りに行こう！"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "材木探し"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "終わらない女ドラフ部屋"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第54章 崩壊の狼煙"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "生き抜く意志と力"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第49章 再びの森"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "第16章 神樹の湖畔"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "ユグドラシル討伐戦"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "メドゥーサ討伐戦"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "ユグドラシル・マグナＨＬ"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "メドゥーサＨＬ"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "置き去りにされたもの"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "遥かなる古を偲ぶ"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "トラップ注意報"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "第20章 のぞむ空"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "アドウェルサ討伐戦"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "アポロン討伐戦"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "オーディン討伐戦"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "シュヴァリエ・マグナＨＬ"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "アポロンＨＬ"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "積み荷の中身は"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "回復魔法の実験台"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "怖がりな騎士"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "第19章 執念と約束"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "部屋の掃除"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "先輩後輩"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "はじめてのお使い"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "メダルを拾うラカム"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "振り向けば アラサー女子"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "第18章 決別の真意"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "ウィル･オ･ウィスプ討伐戦"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "見習い騎士、奮戦！"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "アルビオン支店、補修中"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "縁結びをしよう！"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "置き去りの職業訓練"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "迷子の迷子の……語尾祭りなの！"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "強さと騎士道"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "第17章 困惑の城砦都市"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "親の心、子知らず"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "優勝賞品を狙え！"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "購買危機一髪！"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "眠れる森のお姉様"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "若き騎士達からの挑戦"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "ぬいぐるみファミリー"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "第79章 境界の果て"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "第78章 瘴気の歓待"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "ガブリエルへの挑戦"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "氷窟の契り"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "集落の名物料理"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "第77章 隠れ里"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "極小の大嵐"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "第76章 分かたれた仲間"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "大きさはロマンか否か"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "カマクラ作りに挑戦！"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "第75章 極地の試練"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "生き抜く為に"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "第74章 雪原に潜むもの"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "第73章 オルキスとオーキス"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "第62章 星は空高く"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "崩天、虚空の兆"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "新兵器は機械の獣！？"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "第61章 それぞれの決着"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "第60章 彼が守るもの"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "飛行兵器、襲来"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "復興の道を歩む街"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "第59章 終焉の片鱗"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "第72章 騒乱のアガスティア"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "第58章 それぞれの思惑"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "パン屋さんとだっこ屋さん"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "第56章 黒騎の再来"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "とある帝国兵の矜持"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "五臓六腑に沁みる想い"},	
    { name: "帝都アガスティア", value: "#Agastia", desc: "第55章 隠されしもの"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "帝国旅情"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "ブレイク寸前、ごみ当番"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "第57章 決戦への導き"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "クリス様、奴隷と一緒にWhy！？"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "星の誘い"},	
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "第123章　兆しと再訪"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "第36章 悔恨の行く先"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "ヘビーな食材集め"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "命を張った暇つぶし"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "吟遊詩人志望"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "教えて！ ローアイン♡"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "砂レンガで小物作り！"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "第121章　すくわれる者"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "第63章 彼女の幸せ"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "第35章 力の正体"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "バアル討伐戦"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "ギルガメッシュＨＬ"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "砂漠に花を"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "お宝探し"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "誇り高き贋物職人"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "第120章 偽物達の戦い"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "第71章 囚われの真実"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "第34章 古都の真実"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "迷子のゴーレム"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "思い出の家"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "果実は干からびて"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "エリクシール必須の動物園"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "古物商のプライド"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "老猫の妙技"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "第70章 エルステ王国"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "第33章 奇妙な共闘"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "変えたくないもの"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "青年たちの悩み"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "少女の想いは人形を"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "コンボを決めるカクター親子"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "第42章 砕かれし秩序"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "誰が為に剣は在る"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "第29章 騒乱の出迎え"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "アマルティア島の警備"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "強襲のならず者"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "迷子の脱走者"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "鋭敏な聴覚"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "よろず屋のプライド"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "第65章 新たな旅立ち"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "第44章 誓約の誇り"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "胎動する世界"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "第30章 真実の始まり"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "アテナ討伐戦"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "プロメテウスＨＬ"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "騎空士の過去"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "騒乱の騎空艇団本部"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "空の守り"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "獄中のダイエット大作戦！"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "グロウ・グローリー"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "一番は誰だ"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "第43章 英雄の血"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "第31章 相反する決意"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "策略のならず者"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "追い出された男"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "惚れ薬を飲んだ喰われる"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "新助手誕生？！怪事件の謎を解け"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "負けられない対決！オーディション"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "第41章 再起の声"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "第四騎空艇団人気投票！"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "第32章 真実への船出"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "秩序のあり方"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "新技の犠牲者"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "見栄っ張りな男"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "バイヴカハＨＬ"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "イケメンパラダイス"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "第25章 郷愁の地"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "ガルーダ討伐戦"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "騎空士達の暇潰し"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "新米騎空士の冒険"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "人助けの心意気"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "ガロンゾの古き戦い"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "炎と剣のスパルタレッスン"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "譲れぬもの"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "敬老のポンメルン"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "桃から生まれた土下座対決"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "第26章 淡い約束"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "修理中の魔の手"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "騎空士の街"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "ヘクトルＨＬ"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "未来の騎空士様"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "約束は空の彼方に"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "食堂の伝統"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "遥か空から降るダジャレ大会"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "第119章 旅人の意志"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "第27章 星晶獣ノア"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "誇り高き船大工"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "ガロンゾ労働賛歌"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "開催！ GBC！"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "第28章　思い出の艇"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "思わぬ誤解"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "騎空士が旅立った日"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "ガロンゾに生きる歴史"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "筋肉痛のお渡し会"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "ミスラ討伐戦"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "第21章 霧に潜むもの"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "リンゴ農家の反撃"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "引き裂かれた二人"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "似た者同士"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "空域七不思議・甲冑美女"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "食いしん坊のゾンビ"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "第22章 少女の願い"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "イービルアイ討伐戦"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "宿の看板娘"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "誰がために"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "一回り大きくなって"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "愉快な鬼ごっこ"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "あとの祭り"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "第23章 決意と疑惑"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "アヌビスＨＬ"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "思い出を探しに"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "美しいままで"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "憧れだけで十分"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "団長代理騎空団肝試し大会"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "軍人と勇気と墓参り"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "第24章 不死の星晶獣"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "セレスト討伐戦"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "オリヴィエ討伐戦"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "リッチ討伐戦"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "セレスト・マグナＨＬ"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "Dエンジェル・オリヴィエＨＬ"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "出会いを求めて"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "お化けの正体"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "人騒がせな事件"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "第66章 ふたりの騎士"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "異郷の風に乗って"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "第67章 緋色の過去"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "ラファエルへの挑戦"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "ティアマト・マリスＨＬ"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "岩塊を越えんとする者"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "岩塊に吹く烈風"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "商魂危機一髪"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "ブルジョワの迷惑"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "第68章 失われたもの"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "カー・オンHL"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "第69章 ここにあるもの"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "震天の境界、黄昏の最果"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "靂天の境界、紫電の黎明"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "黄龍・黒麒麟ＨＬ"},
    { name: "境界の世界", value: "#The_Edgelands", desc: "第114章 福音からの帰還"},
    { name: "境界の世界", value: "#The_Edgelands", desc: "ダーク・ラプチャー"},
    { name: "境界の世界", value: "#The_Edgelands", desc: "ダーク・ラプチャー(HARD)"},
    { name: "境界の世界", value: "#The_Edgelands", desc: "第113章 ミカという少女"},
    { name: "境界の世界", value: "#The_Edgelands", desc: "第112章 父の足跡"},
    { name: "境界の世界", value: "#The_Edgelands", desc: "第111章 境界の世界"},
    { name: "グロース島", value: "#Groz_Island", desc: "第124章 異形の空"},
    { name: "グロース島", value: "#Groz_Island", desc: "第101章 衝突"},
    { name: "グロース島", value: "#Groz_Island", desc: "第84章 イデルバ王国"},
    { name: "グロース島", value: "#Groz_Island", desc: "力ある者の使命"},
    { name: "グロース島", value: "#Groz_Island", desc: "第85章 少女フォリア"},
    { name: "グロース島", value: "#Groz_Island", desc: "ウリエルへの挑戦"},
    { name: "グロース島", value: "#Groz_Island", desc: "呼応する大地の化身"},
    { name: "グロース島", value: "#Groz_Island", desc: "束の間の絶景"},
    { name: "グロース島", value: "#Groz_Island", desc: "第94章 教えの最奥"},
    { name: "グロース島", value: "#Groz_Island", desc: "第95章 ふたりの世界"},
    { name: "グロース島", value: "#Groz_Island", desc: "第96章 燻る火種"},
    { name: "グロース島", value: "#Groz_Island", desc: "十天衆を総べし者"},   
    { name: "グロース島", value: "#Groz_Island", desc: "第97章 星の獣と踊る者"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "メタトロンＨＬ"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "アバターＨＬ"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "第89章 賢者の教え"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "光の試練"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "楽園追放"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "第88章 囚われた仲間"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "シヴァＨＬ"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "エウロペＨＬ"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "ブローディアＨＬ"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "グリームニルＨＬ"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "第87章 思わぬ再会"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "ガラダさんは負けたくない"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "滅炎と舞う"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "殿上の聖泉"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "不可侵神域"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "踊り狂う暴風"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "第86章 千里眼の賢者"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "第125章 欠片を求めて"},
    { name: "メルクマール島", value: "#Merkmal_Island", desc: "しこたま貯め込んでやがる"},
    { name: "メルクマール島", value: "#Merkmal_Island", desc: "第80章 見知らぬ空"},
    { name: "メルクマール島", value: "#Merkmal_Island", desc: "瓦礫の部屋の主"},
    { name: "メルクマール島", value: "#Merkmal_Island", desc: "第81章 盗賊王"},
    { name: "メルクマール島", value: "#Merkmal_Island", desc: "ミカエルへの挑戦"},
    { name: "メルクマール島", value: "#Merkmal_Island", desc: "顕現せし憤懣の劫火"},
    { name: "メルクマール島", value: "#Merkmal_Island", desc: "第82章 カインの罠"},
    { name: "メルクマール島", value: "#Merkmal_Island", desc: "第83章 決着と新たな旅路"},
    { name: "シュテルケ島", value: "#Starke_Island", desc: "第110章 真実の守り人"},
    { name: "シュテルケ島", value: "#Starke_Island", desc: "第109章 抗う者達"},
    { name: "シュテルケ島", value: "#Starke_Island", desc: "第108章 集う意志"},
    { name: "ライヒェ島", value: "#Reiche_Island", desc: "第102章 決意の始まり"},
    { name: "ライヒェ島", value: "#Reiche_Island", desc: "第103章 最後の鍵"},
    { name: "ライヒェ島", value: "#Reiche_Island", desc: "第106章 天罰"},
    { name: "ライヒェ島", value: "#Reiche_Island", desc: "第104章 交錯する意思"},
    { name: "ライヒェ島", value: "#Reiche_Island", desc: "第126章　相対の意思"},
    { name: "ライヒェ島", value: "#Reiche_Island", desc: "第107章 変貌する闇"},
    { name: "ライヒェ島", value: "#Reiche_Island", desc: "第105章 再戦"},
    { name: "ベスティエ島", value: "#Bestia_Island", desc: "第90章 獣の島"},
    { name: "ベスティエ島", value: "#Bestia_Island", desc: "第98章 蠢く凶兆"},
    { name: "ベスティエ島", value: "#Bestia_Island", desc: "第91章 百獣の母"},
    { name: "ベスティエ島", value: "#Bestia_Island", desc: "神撃、究極の竜HL"},
    { name: "ベスティエ島", value: "#Bestia_Island", desc: "神撃の試練"},
    { name: "ベスティエ島", value: "#Bestia_Island", desc: "第99章 痛みの記憶"},
    { name: "ベスティエ島", value: "#Bestia_Island", desc: "第92章 狂気の襲来"},
    { name: "ベスティエ島", value: "#Bestia_Island", desc: "神撃、究極の竜"},
    { name: "ベスティエ島", value: "#Bestia_Island", desc: "第100章 観劇者の答え"},
    { name: "ベスティエ島", value: "#Bestia_Island", desc: "第93章 終焉の幕開け"},
    { name: "ベスティエ島", value: "#Bestia_Island", desc: "四大天司ＨＬ"},
    { name: "ザンクティンゼル", value: "#Zinkenstill", desc: "ザンクティンゼル"},
    { name: "ポート・ブリーズ群島", value: "#Port_Breeze_Archipelago", desc: "ポート・ブリーズ群島"},
    { name: "バルツ公国", value: "#Valtz_Duchy", desc: "バルツ公国"},
    { name: "アウギュステ列島", value: "#Auguste_Isles", desc: "アウギュステ列島"},
    { name: "ルーマシー群島", value: "#Lumacie_Archipelago", desc: "ルーマシー群島"},
    { name: "城塞都市アルビオン", value: "#Albion_Citadel", desc: "城塞都市アルビオン"},
    { name: "白風の境(ノース・ヴァスト)", value: "#Silverwind_Stretch_North_Vast", desc: "白風の境(ノース・ヴァスト)"},
    { name: "帝都アガスティア", value: "#Agastia", desc: "帝都アガスティア"},
    { name: "旧王都メフォラシュ", value: "#Former_Capital_Mephorash", desc: "旧王都メフォラシュ"},
    { name: "アマルティア島", value: "#Amalthea_Island", desc: "アマルティア島"},
    { name: "ガロンゾ島", value: "#Golonzo_Island", desc: "ガロンゾ島"},
    { name: "霧に包まれた島", value: "#Mist_Shrouded_Isle", desc: "霧に包まれた島"},
    { name: "ダイダロイトベルト", value: "#Dydroit_Belt", desc: "ダイダロイトベルト"},
    { name: "境界の世界", value: "#The_Edgelands", desc: "境界の世界"},
    { name: "グロース島", value: "#Groz_Island", desc: "グロース島"},
    { name: "クルーガー島", value: "#Kluger_Island", desc: "クルーガー島"},
    { name: "メルクマール島", value: "#Merkmal_Island", desc: "メルクマール島"},
    { name: "シュテルケ島", value: "#Starke_Island", desc: "シュテルケ島"},
    { name: "ライヒェ島", value: "#Reiche_Island", desc: "ライヒェ島"},
    { name: "ベスティエ島", value: "#Bestia_Island", desc: "ベスティエ島"},
]